import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import SimpleBar from "simplebar-react"

import VerticalLayout from "./VerticalLayouts"
import MenuFilter from "./VerticalLayouts/MenuFilter"
import TwoColumnLayout from "./TwoColumnLayout"
import HorizontalLayout from "./HorizontalLayout"
import { LayoutTypes } from "@/enums/layout"
import { useTenant } from "@/contexts/TenantContext"



interface SidebarProps {
  layoutType: LayoutTypes
}

const Sidebar: React.FC<SidebarProps> = ({ layoutType }) => {
  const { tenant } = useTenant()
  const logoMenu = tenant?.logoMenu || import.meta.env.VITE_LOGO_MENU || ""
  const logoMenuSm = tenant?.logoMenuSm || import.meta.env.VITE_LOGO_MENU_SM || ""
  // Filtro del menú (solo layout vertical); no persiste a propósito
  const [menuFilter, setMenuFilter] = useState("")

  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay")
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable")
      })
    }
  })

  return (
    <React.Fragment>
      {/* <nav> landmark: los estilos van por clase, el tag no afecta el CSS */}
      <nav className="app-menu navbar-menu" aria-label="Navegación principal">
        <div className="navbar-brand-box">
          <Link to="/" className="logo sidebar-logo-link">
            <img
              src={logoMenu || logoMenuSm}
              alt="Logo"
              className="sidebar-logo-img sidebar-logo-main"
            />
          </Link>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <div className="container-fluid">
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout layoutType={layoutType} />
              </ul>
            </div>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <MenuFilter value={menuFilter} onChange={setMenuFilter} />
            <SimpleBar id="scrollbar" className="h-100">
              <div className="container-fluid">
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} filterText={menuFilter} />
                </ul>
              </div>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </nav>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  )
}

export default Sidebar
